export default {"src":"/_next/static/media/ArrowLanguageHeader.dda42f21.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};